import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=41aa9354&"
import script from "./GroupHeader.vue?vue&type=script&lang=js&"
export * from "./GroupHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports